import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import PresentationCard from 'components/card/PresentationCard'
import { IMPORT_TYPE, HEIGHT_INTEGRATION, DEBIT_INTEGRATION, STATION_INTEGRATION, DATA_ADD_LAST_DATA, WITHPRED } from 'traitements/constants/TraitementConstants'
import DtoHydrometricStation from 'hydrometry/dto/DtoHydrometricStation'
import shomLogo from 'assets/pictures/logos/shom.png'
import hydroPortailLogo from 'assets/pictures/logos/hydroportail.png'
import EtiagesOndeLogo from 'assets/pictures/logos/EtiagesOnde.png'

const getDefaultParams = (stationType) => {
    switch (stationType) {
        case IMPORT_TYPE.HYDRO_PORTAIL:
            return {
                filters: [],
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA, WITHPRED, HEIGHT_INTEGRATION, DEBIT_INTEGRATION, 'withEvents', 'withThresholds'],
            }
        default:
            return { filters: {}, dataTypes: [] }
    }
}

const updateParams = (stationType, setFilters, setJobDataTypes) => {
    const params = getDefaultParams(stationType)
    setFilters(params.filters)
    setJobDataTypes(params.dataTypes)
}

const AddHydroStepStation = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setChoices,
}) => {
    const centerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }
    return (
        <Grid container justifyContent='center' alignItems='center' spacing={3}>
            <Grid size={6}>
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={hydroPortailLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title= {i18n.hydroPortail}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.hydroPortail})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE.HYDRO_PORTAIL })
                        updateParams(IMPORT_TYPE.HYDRO_PORTAIL, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.hydroPortailDescription}
                />
            </Grid>
            <Grid size={6}>
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={EtiagesOndeLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title= {i18n.lowWaterOnde}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.lowWaterOnde})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE.LOW_WATER_ONDE })
                        updateParams(IMPORT_TYPE.LOW_WATER_ONDE, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.flowMonitoringStation}
                />
            </Grid>
            <Grid size={6}>
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={shomLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title= {i18n.tidegauge}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.tidegauge})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE.TIDE_GAUGE })
                        updateParams(IMPORT_TYPE.TIDE_GAUGE, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.coastalMonitoringStation}
                />
            </Grid>
        </Grid>
    )
}

AddHydroStepStation.propTypes = {
    station: PropTypes.instanceOf(DtoHydrometricStation),
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    setChoices: PropTypes.func,
}

export default AddHydroStepStation